import { msg } from "@lingui/core/macro";

export const locationChoiceRuleMessages = {
	name: msg({ message: "Location Choice Required" }),
	description: msg({ message: "Permit requires selecting exactly one location" }),
	errors: {
		empty: msg({ message: "Please select a location." }),
		single: msg({ message: "Please select exactly one location." }),
	},
} as const;
